<template lang="pug">
  .maptalks-map(:id='id')
    slot(v-if='ready')
</template>

<script>
import { createMap, createBaseLayer } from '@/utils/map'
import { MAP_PITCH, MAP_BASE_LAYER_URL } from '@/app.config'

const events = [
  'zoomend'
]

export default {
  name: 'maptalks-map',
  props: {
    id: {
      type: String,
      default: 'map'
    },
    pitch: {
      type: Number,
      default: MAP_PITCH
    },
    base: {
      type: String,
      default: MAP_BASE_LAYER_URL
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      mapObject: null,
      ready: false
    }
  },
  watch: {
    pitch () {
      this.mapObject.setPitch(this.pitch)
    },
    base () {
      this.mapObject.setBaseLayer(createBaseLayer(this.base))
    }
  },
  mounted () {

    const options = {
      ...this.options,
      pitch: this.pitch
    }

    const map = createMap({
      id: this.id,
      options
    })

    events.forEach(event => {
      map.on(event, ev => {
        this.$emit(`mt-${event}`, ev)
      })
    })

    this.mapObject = map
    this.ready = true
  },
  beforeDestroy () {
    this.mapObject.remove()
  }
}
</script>

<style scoped>
.maptalks-map {
  width: 100%;
  height: 100%;
}
</style>